var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.80289 9.18227C1.54689 9.18227 1.29089 9.08494 1.09622 8.88894C0.705556 8.49827 0.705556 7.86627 1.09622 7.47561L7.48556 1.08627C7.87622 0.695607 8.50822 0.695607 8.89889 1.08627C9.28956 1.47694 9.28956 2.10894 8.89889 2.49961L2.50956 8.88894C2.31489 9.08494 2.05889 9.18227 1.80289 9.18227Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19512 9.18613C7.93912 9.18613 7.68311 9.0888 7.48845 8.8928L1.09378 2.4968C0.703115 2.10613 0.703115 1.47413 1.09378 1.08347C1.48578 0.6928 2.11778 0.6928 2.50711 1.08347L8.90178 7.47947C9.29245 7.87013 9.29245 8.50213 8.90178 8.8928C8.70711 9.0888 8.44978 9.18613 8.19512 9.18613Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3df5ed132158d3f8762252ea4355a673.svg";
export { ForwardRef as ReactComponent };